import { Selection } from  "src/types";

export const generateCacheProductId = ({ product, locale }: Selection) => {
    if (!product?.id) {
        return '';
    }
    return `${product.id}___${locale}`
}